/* Revotronics cookie consent – writes choices to Shopify's Customer Privacy API. */
(function () {
  if (customElements.get('revo-consent')) return;
  const KEYS = ['preferences', 'analytics', 'marketing'];

  function withPrivacyApi(cb) {
    const ready = () => window.Shopify && window.Shopify.customerPrivacy;
    if (ready()) return cb(window.Shopify.customerPrivacy);
    const load = () => {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
        if (err || !ready()) return cb(null);
        cb(window.Shopify.customerPrivacy);
      });
    };
    if (window.Shopify && window.Shopify.loadFeatures) return load();
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      if (window.Shopify && window.Shopify.loadFeatures) { clearInterval(t); load(); }
      else if (tries > 100) { clearInterval(t); cb(null); }
    }, 50);
  }

  class RevoConsent extends HTMLElement {
    connectedCallback() {
      this.prefs = this.querySelector('.revo-consent__prefs');
      this.btnSave = this.querySelector('[data-action="save"]');
      this.btnSettings = this.querySelector('[data-action="settings"]');
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-action]');
        if (!b) return;
        const a = b.dataset.action;
        if (a === 'accept') this.save({ preferences: true, analytics: true, marketing: true });
        if (a === 'reject') this.save({ preferences: false, analytics: false, marketing: false });
        if (a === 'settings') this.togglePrefs();
        if (a === 'save') this.save(this.readSwitches());
      });
      // reopen from any link to #cookie-einstellungen or element with data-revo-consent-open
      document.addEventListener('click', (e) => {
        const l = e.target.closest('a[href$="#cookie-einstellungen"], [data-revo-consent-open]');
        if (!l) return;
        e.preventDefault();
        this.open(true);
      });
      window.RevoConsent = { open: () => this.open(true) };

      withPrivacyApi((api) => {
        this.api = api;
        if (this.hasAttribute('data-preview')) return this.open(false);
        if (!api) return; // API unavailable: never block the shop
        const c = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
        // German shop: always ask until the visitor has decided (independent of Shopify's region setting)
        const undecided = KEYS.some((k) => c[k] !== 'yes' && c[k] !== 'no');
        if (undecided) this.open(false);
      });
    }

    readSwitches() {
      const out = {};
      this.querySelectorAll('[data-consent]').forEach((i) => (out[i.dataset.consent] = i.checked));
      return out;
    }

    fillSwitches() {
      const c = this.api && this.api.currentVisitorConsent ? this.api.currentVisitorConsent() : {};
      this.querySelectorAll('[data-consent]').forEach((i) => (i.checked = c[i.dataset.consent] === 'yes'));
    }

    togglePrefs(force) {
      const show = force ?? this.prefs.hidden;
      this.prefs.hidden = !show;
      this.btnSave.hidden = !show;
      this.btnSettings.setAttribute('aria-expanded', String(show));
      this.btnSettings.hidden = show;
      if (show) this.fillSwitches();
    }

    open(withPrefs) {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.togglePrefs(!!withPrefs);
      const first = this.querySelector('[data-action="reject"]');
      if (withPrefs && first) first.focus({ preventScroll: true });
    }

    close() {
      this.classList.remove('is-open');
      setTimeout(() => (this.hidden = true), 250);
    }

    save(choice) {
      const done = () => this.close();
      if (!this.api || !this.api.setTrackingConsent) return done();
      try {
        this.api.setTrackingConsent(choice, () => {
          document.dispatchEvent(new CustomEvent('revo:consent', { detail: choice }));
          done();
        });
      } catch (e) {
        done();
      }
    }
  }
  customElements.define('revo-consent', RevoConsent);
})();
